import { __module as a } from "./ghl-ui.es1713.js";
(function(o, t) {
  Object.defineProperty(t, "__esModule", {
    value: !0
  }), t.default = d;
  function d(r, n) {
    for (var i = r < 0 ? "-" : "", e = Math.abs(r).toString(); e.length < n; )
      e = "0" + e;
    return i + e;
  }
  o.exports = t.default;
})(a, a.exports);
var u = a.exports;
export {
  u as a
};
